import { API_URL } from '../../config'

export function createCommunicationsModule(apiUrl, request = (...args) => fetch(...args)) {
  const call = async (token, path, options = {}, binary = false) => {
    if (!token) throw Error('Inicie sesión para continuar.')
    const response = await request(`${apiUrl}/comunicaciones${path}`, {
      ...options,
      headers: { 'Content-Type': 'application/json', ...options.headers,
        Authorization: 'Bearer ' + String(token).replace(/^Bearer\s+/i, '').trim() }
    })
    if (binary && response.ok) return response.blob()
    const result = await response.json()
    if (!response.ok || result.exito !== 1) throw Error(result.message || 'No se pudo completar la solicitud.')
    return result.data
  }
  const query = (offset, type) => `?offset=${offset}${type ? `&type=${encodeURIComponent(type)}` : ''}`
  return {
    namespaced: true,
    actions: {
      access: ({ rootState }) => call(rootState.token, '/access'),
      list: ({ rootState }, { offset = 0, type = '' } = {}) => call(rootState.token, query(offset, type)),
      download: ({ rootState }, id) => call(rootState.token, `/files/${encodeURIComponent(id)}`, {}, true),
      async edit({ rootState }, { id, title, description, type }) {
        const token = rootState.token
        const result = await call(token, `/${encodeURIComponent(id)}`, {
          method: 'PUT', body: JSON.stringify({ title, description, type })
        })
        if (rootState.token !== token) throw Error('La sesión cambió. Intente nuevamente.')
        return result
      },
      async remove({ rootState }, id) {
        const token = rootState.token
        const result = await call(token, `/${encodeURIComponent(id)}`, { method: 'DELETE' })
        if (rootState.token !== token) throw Error('La sesión cambió. Intente nuevamente.')
        return result
      },
      async publish({ rootState }, { title, description, type, files = [] }) {
        // Capture identity for the entire lifecycle; do not mix accounts mid-upload.
        const token = rootState.token
        const draft = await call(token, '/drafts', { method: 'POST', body: JSON.stringify({ title, description, type, fileCount: files.length }) })
        try {
          for (const file of files) {
            if (rootState.token !== token) throw Error('La sesión cambió durante la publicación.')
            await call(token, `/drafts/${draft.id}/files`, {
              method: 'POST', body: file,
              headers: { 'Content-Type': 'application/octet-stream', 'X-File-Name': encodeURIComponent(file.name),
                'X-File-Type': file.type, 'X-File-Size': String(file.size) }
            })
          }
          if (rootState.token !== token) throw Error('La sesión cambió durante la publicación.')
          return await call(token, `/drafts/${draft.id}/finalize`, { method: 'POST', body: '{}' })
        } catch (error) {
          try { await call(token, `/drafts/${draft.id}`, { method: 'DELETE' }) } catch (_) { /* private draft expires; never visible in feed */ }
          throw error
        }
      }
    }
  }
}
export default createCommunicationsModule(API_URL)
